export default __webpack_public_path__ + "static/284-1ebc1b2b261cf55f2e0eb9a492d430ee.gif";